var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"flow-chart"},[_c('b-col',[_c('flowy',{staticClass:"justify-content-center",attrs:{"nodes":_vm.nodes},on:{"click":function($event){return _vm.$emit('click', 'values')}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }